import { useViewModel } from '@descomplica/microfrontend-react';
import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { Button } from '@/shared/presentation/components/ui/Button';
import { DataTable } from '@/shared/presentation/components/ui/DataTable';
import { Page } from '@/shared/presentation/components/ui/Page';

import { SSORegistrationsViewModel } from './SSORegistrations.vm';

export const SSORegistrationsScreen = observer(() => {
  const vm = useViewModel(SSORegistrationsViewModel);
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        name: 'Código',
        grow: 4,
        selector: (row) => row.guid,
      },
      {
        name: 'Provedor',
        selector: (row) => row.provider,
      },
      {
        name: 'Escopo',
        selector: (row) => row.scope.name,
      },
      {
        name: 'Papel',
        selector: (row) => row.role.name,
      },
      {
        name: 'Tag',
        selector: (row) => row.tag,
      },
      {
        name: 'Url de cadastro',
        selector: (row) => (
          <a
            href={`#`}
            onClick={(e) => {
              try {
                e.preventDefault();
                navigator.clipboard.writeText(row.url);
                toast.success('Link copiado para a área de transferência');
              } catch (error) {
                console.log(row.url);
                console.error(error);
                toast.error('Erro ao copiar o link');
              }
            }}
          >
            Copiar link
          </a>
        ),
      },
    ],
    [],
  );

  const actions = useMemo(() => [], []);

  return (
    <Page
      title="SSO"
      subtitle={`Gerencie as urls de cadastros via SSO`}
      isLoading={vm.isLoading}
      hasError={vm.hasError}
      errorMessage="Ocorreu um erro ao carregar os links."
      headerActions={() => (
        <Button
          icon="add"
          size="small"
          disabled={vm.isLoading}
          onClick={() => {
            navigate('/admin/sso/registrations/create');
          }}
        >
          Criar url de cadastro via SSO
        </Button>
      )}
    >
      <DataTable
        isLoading={vm.isLoading}
        columns={columns}
        data={vm.ssoRegistration}
        actions={actions}
        searchPlaceholder="Pesquisar"
      />
    </Page>
  );
});
